import { getPersistedFilterKey } from "modules/common/hooks/usePersistedFilters";

import type { CustomerBankListFilters } from "../models/Filters";

export const FILTERS_KEYS = {
  COUNTRIES: "country",
  CURRENCY: "currency",
  BANK_GROUP: "bankGroup",
  PIS_STATUS: "pisStatus",
  PIS_VISIBLE: "pisVisible",
  CONFIGURATION_STATE: "configurationState",
} as const;

export const DEFAULT_FILTERS = {
  [FILTERS_KEYS.COUNTRIES]: [],
  [FILTERS_KEYS.CURRENCY]: [],
  [FILTERS_KEYS.BANK_GROUP]: [],
  [FILTERS_KEYS.PIS_STATUS]: [],
  [FILTERS_KEYS.PIS_VISIBLE]: [],
  [FILTERS_KEYS.CONFIGURATION_STATE]: [],
} as const satisfies CustomerBankListFilters;

export const DEFAULT_FILTERS_CONFIGURATION = {
  [FILTERS_KEYS.COUNTRIES]: { array: true as const, defaultValue: [] },
  [FILTERS_KEYS.CURRENCY]: { array: true as const, defaultValue: [] },
  [FILTERS_KEYS.BANK_GROUP]: { array: true as const, defaultValue: [] },
  [FILTERS_KEYS.PIS_STATUS]: { array: true as const, defaultValue: [] },
  [FILTERS_KEYS.PIS_VISIBLE]: { array: true as const, defaultValue: [] },
  [FILTERS_KEYS.CONFIGURATION_STATE]: {
    array: true as const,
    defaultValue: [],
  },
};

export const FILTERS_PERSISTED_KEY = getPersistedFilterKey("customer-banks");
